<template>
  <div class="mb-6 space-y-1">
    <div class="flex items-center gap-10">
      <div class="flex items-center gap-2 text-gray-darker w-30">
        <icon :icon="mdiTextBoxOutline" :size="IconSize.SM" />
        <span class="leading-none text-xs">
          {{ $t('brand-surveys.survey-question-modal.survey') }}
        </span>
      </div>
      <span class="leading-none text-xs font-bold text-blue">
        {{ surveyInternalNumber ? `#${surveyInternalNumber}` : '-' }}
      </span>
    </div>
    <div class="flex items-center gap-10">
      <div class="flex items-center gap-2 text-gray-darker w-30">
        <icon :icon="mdiAccountOutline" :size="IconSize.SM" />
        <span class="leading-none text-xs">
          {{ $t('brand-surveys.survey-question-modal.respondent') }}
        </span>
      </div>
      <span class="leading-none text-xs font-bold">
        {{ userFullName || '-' }}
      </span>
    </div>

    <div class="flex items-center gap-10">
      <div class="flex items-center gap-2 text-gray-darker w-30">
        <icon :icon="mdiMapMarkerOutline" :size="IconSize.SM" />
        <span class="leading-none text-xs">
          {{ $t('brand-surveys.survey-question-modal.place') }}
        </span>
      </div>
      <span class="leading-none text-xs font-bold">
        {{ placeName || '-' }}
      </span>
    </div>
  </div>
</template>

<script>
import { Icon, IconSize } from '@/components/Icon';
import {
  mdiTextBoxOutline,
  mdiAccountOutline,
  mdiMapMarkerOutline,
} from '@mdi/js';

export default {
  name: 'SurveyQuestionModalHeader',
  components: {
    Icon,
  },
  props: {
    surveyInternalNumber: {
      type: Number,
      default: null,
    },
    userFullName: {
      type: String,
      default: null,
    },
    placeName: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      IconSize,
      mdiTextBoxOutline,
      mdiAccountOutline,
      mdiMapMarkerOutline,
    };
  },
};
</script>
